<template>
    <div class="stockScoreDetail">
        <div :class="ssdHeadClasses">
            <div class="ssdTitle">
                <div class="ssdName">{{ subScoreName }}</div>
                <div class="ssdWeight">({{ subScoreWeight }}%)</div>
            </div>
            <div class="ssdScore">{{ subScore }}</div>
        </div>
        <div v-if="hasUsedVariables" class="scoreDetailRows">
            <StockScoreDetailRow v-for="(ssd, i) in getUsedVarName(scoreDetail.usedVariables)" :key="i" :scoreDetailRow="ssd" />
        </div>
    </div>
</template>

<script>
import StockScoreDetailRow from './StockScoreDetailRow.vue';
export default {
    props: ['scoreDetail'],
    components: {
        StockScoreDetailRow
    },
    computed: {
        ssdHeadClasses() {
            return this.subScoreWeight > 0 ? "ssdHead" : "ssdHead zw";
        },
        hasUsedVariables() {
            return this.scoreDetail.usedVariables && Object.keys(this.scoreDetail.usedVariables).length > 0;
        },
        subScoreWeight() {
            return this.scoreDetail.weighting ? this.scoreDetail.weighting * 100 : "0";
        },
        subScoreName() {
            return this.$t(`subScore.${this.scoreDetail.subScoreName}`);
        },
        subScore() {
            return this.scoreDetail.score ? this.scoreDetail.score.toFixed(2) : "";
        }
    },
    methods: {
        getUsedVarName(usedVariables) {
            const result = [];
            if (!usedVariables) { return result; }
            Object.keys(usedVariables).forEach(key => {
                result.push({
                    name: key,
                    value: usedVariables[key]
                });
            });
            return result;
        }
    }
}
</script>

<style lang="scss" scoped>
.stockScoreDetail {
    background-color: #FFF;
    display: flex;
    flex-direction: column;
    gap: 5px;
    .ssdHead {
        background-color: var(--v-agorabg-base);
        padding: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.zw {
            background-color: var(--v-lightGrayBG-base);
            .ssdScore {
                font-weight: normal;
            }
        }
        .ssdTitle {
            display: flex;
            align-items: center;
            gap: 5px;
            .ssdName {
                font-weight: bold;
            }
        }
        .ssdScore {
            font-weight: bold;
        }
    }
    .scoreDetailRows {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 5px;
    }
}
</style>